export default __webpack_public_path__ + "static/media/Category-18.bff11566.jpg";